<template>
  <div class="report-detail-page">
    <layout-header :isFixedHeader="false"></layout-header>

    <div class="container" v-if="isReady">
      <div class="report-wrap" style="margin-top: 8rem;">
        <h1 class="title">
          <button type="button" class="btn-back" @click="$router.go(-1)">
            목록으로
          </button>
          세부내역
          <button type="button" class="btn-report-download" @click="downloadReport">
            보고서 다운
          </button>
        </h1>
        <div style="clear: both;"></div>
        <div class="using-wrap twice">
          <h4 class="sub-title">사용량 내역 (II)</h4>
          <table class="table">
            <thead>
            <tr>
              <th colspan="2">고객번호</th>
              <th class="text-center">{{ assetData.customerNumber1 }}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th rowspan="4">사용량<br>(Kwh)</th>
              <th>중부하</th>
              <td class="text-right number">{{ $Util.formatNumber(assetData.heavyLoad1_1 + assetData.heavyLoad1_2) }}</td>
            </tr>
            <tr>
              <th>최대부하</th>
              <td class="text-right number">{{ $Util.formatNumber(assetData.maxLoad1_1 + assetData.maxLoad1_2) }}</td>
            </tr>
            <tr>
              <th>경부하</th>
              <td class="text-right number">{{ $Util.formatNumber(assetData.lightLoad1_1 + assetData.lightLoad1_2) }}</td>
            </tr>
            <tr>
              <th>합계</th>
              <td class="text-right number">{{
                  $Util.formatNumber(
                    assetData.heavyLoad1_1
                    + assetData.heavyLoad1_2
                    + assetData.maxLoad1_1
                    + assetData.maxLoad1_2
                    + assetData.lightLoad1_1
                    + assetData.lightLoad1_2
                  )
                }}
              </td>
            </tr>
            <tr>
              <th colspan="2">사용기간</th>
              <td class="text-center">
                {{ `${$moment(assetData.startUseDate1).format('YYYY.MM.DD')}~${$moment(assetData.endUseDate1).format('YYYY.MM.DD')}` }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="using-wrap twice" v-if="assetData.customerType === 2">
          <h4 class="sub-title">사용량 내역 (III)</h4>
          <table class="table">
            <thead>
            <tr>
              <th colspan="2">고객번호</th>
              <th class="text-center">{{ assetData.customerNumber1 }}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th rowspan="4">사용량<br>(Kwh)</th>
              <th>중부하</th>
              <td class="text-right number">{{ $Util.formatNumber(assetData.heavyLoad2_1 + assetData.heavyLoad2_2) }}</td>
            </tr>
            <tr>
              <th>최대부하</th>
              <td class="text-right number">{{ $Util.formatNumber(assetData.maxLoad2_1 + assetData.heavyLoad2_2) }}</td>
            </tr>
            <tr>
              <th>경부하</th>
              <td class="text-right number">{{ $Util.formatNumber(assetData.lightLoad2_1 + assetData.heavyLoad2_2) }}</td>
            </tr>
            <tr>
              <th>합계</th>
              <td class="text-right number">{{
                  $Util.formatNumber(
                    assetData.heavyLoad2_1
                    + assetData.heavyLoad2_2
                    + assetData.maxLoad2_1
                    + assetData.maxLoad2_2
                    + assetData.lightLoad2_1
                    + assetData.lightLoad2_2
                  )
                }}
              </td>
            </tr>
            <tr>
              <th colspan="2">사용기간</th>
              <td class="text-center" v-if="!$Util.isEmpty(assetData.startUseDate2) && !$Util.isEmpty(assetData.endUseDate2)">
                {{ `${$moment(assetData.startUseDate2).format('YYYY.MM.DD')}~${$moment(assetData.endUseDate2).format('YYYY.MM.DD')}` }}
              </td>
              <td class="text-center" v-else>
                {{ `${$moment(assetData.startUseDate1).format('YYYY.MM.DD')}~${$moment(assetData.endUseDate1).format('YYYY.MM.DD')}` }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="using-wrap">
          <h4 class="sub-title">절감 세부 내역</h4>
          <div class="table-wrap">
            <table class="table">
              <thead>
              <tr>
                <th class="detail-title">구분</th>
                <th class="detail-title">컨설팅 전( I )</th>
                <th class="detail-title">컨설팅 후(Ⅱ)<br>(당월청구요금)</th>
                <th class="detail-title" v-if="assetData.customerType === 2">컨설팅 후(Ⅲ)<br>(당월청구요금)</th>
                <th class="detail-title">절감액<br>{{ assetData.customerType === 2 ? '(I-(Ⅱ+Ⅲ))' : '( I - Ⅱ)' }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th class="detail-title">기본요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeBasic) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterBasic1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterBasic2) }}</td>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeBasic - (assetData.afterBasic1 + assetData.afterBasic2)) }}</th>
              </tr>
              <tr>
                <th class="detail-title">전력량 요금(합계)</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeTotalLoad) }}</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.afterTotalLoad1) }}</th>
                <th class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterTotalLoad2) }}</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeTotalLoad - (assetData.afterTotalLoad1 + assetData.afterTotalLoad2)) }}</th>
              </tr>
              <tr>
                <th class="detail-title">경부하 요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeLightLoad) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterLightLoad1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterLightLoad2) }}</td>
                <td class="text-right number">
                  {{ $Util.formatNumber(assetData.beforeLightLoad - (assetData.afterLightLoad1 + assetData.afterLightLoad2)) }}
                </td>
              </tr>
              <tr>
                <th class="detail-title">중부하 요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeHeavyLoad) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterHeavyLoad1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterHeavyLoad2) }}</td>
                <td class="text-right number">
                  {{ $Util.formatNumber(assetData.beforeHeavyLoad - (assetData.afterHeavyLoad1 + assetData.afterHeavyLoad2)) }}
                </td>
              </tr>
              <tr>
                <th class="detail-title">최대부하 요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeMaxLoad) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterMaxLoad1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterMaxLoad2) }}</td>
                <td class="text-right number">
                  {{ $Util.formatNumber(assetData.beforeMaxLoad - (assetData.afterMaxLoad1 + assetData.afterMaxLoad2)) }}
                </td>
              </tr>
              <tr>
                <th class="detail-title">환경비용 차감</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeEnvironment) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterEnvironment1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterEnvironment2) }}</td>
                <td class="text-right number">
                  {{ $Util.formatNumber(assetData.beforeEnvironment - (assetData.afterEnvironment1 + assetData.afterEnvironment2)) }}
                </td>
              </tr>
              <tr>
                <th class="detail-title">역률 요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforePowerFactor.toFixed()) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterPowerFactor1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterPowerFactor1) }}</td>
                <th class="text-right number">
                  {{ $Util.formatNumber((assetData.beforePowerFactor + assetData.afterPowerFactor1 + assetData.afterPowerFactor2).toFixed()) }}
                </th>
              </tr>
              <tr>
                <th class="detail-title">자동이체 할인</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeAutoDiscount) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterAutoDiscount1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterAutoDiscount2) }}</td>
                <td class="text-right number">
                  {{ $Util.formatNumber(assetData.beforeAutoDiscount - (assetData.afterAutoDiscount1 + assetData.afterAutoDiscount2)) }}
                </td>
              </tr>
              <tr>
                <th class="detail-title">기후환경 요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeClimate) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterClimate1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterClimate2) }}</td>
                <td class="text-right number">{{
                    $Util.formatNumber(assetData.beforeClimate - (assetData.afterClimate1 + assetData.afterClimate2))
                  }}
                </td>
              </tr>
              <tr>
                <th class="detail-title">연료비 조정액</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeFuelAdjust) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterFuelAdjust1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterFuelAdjust2) }}</td>
                <td class="text-right number">
                  {{ $Util.formatNumber(assetData.beforeFuelAdjust - (assetData.afterFuelAdjust1 + assetData.afterFuelAdjust2)) }}
                </td>
              </tr>
              <tr>
                <th class="detail-title">부가가치세</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeVat) }}</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.afterVat1) }}</th>
                <th class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterVat2) }}</th>
                <th class="text-right number" v-if="userData.electData.vatExpectType === 2">0</th>
                <th class="text-right number" v-else>{{ $Util.formatNumber(assetData.resultVat) }}</th>
              </tr>
              <tr>
                <th class="detail-title">전력기금</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeElectricFund) }}</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.afterElectricFund1) }}</th>
                <th class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterElectricFund2) }}</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeElectricFund - (assetData.afterElectricFund1 + assetData.afterElectricFund2)) }}</th>
              </tr>
              <tr>
                <th class="detail-title">당월 요금계</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeMonthBill) }}</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.afterMonthBill1) }}</th>
                <th class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterMonthBill2) }}</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeMonthBill - (assetData.afterMonthBill1 + assetData.afterMonthBill2)) }}</th>
              </tr>
              <tr>
                <th class="detail-title">TV수신료</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeTvLicense) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTvLicense1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterTvLicense2) }}</td>
                <td class="text-right number">
                  {{ $Util.formatNumber(assetData.beforeTvLicense - (assetData.afterTvLicense1 + assetData.afterTvLicense2)) }}
                </td>
              </tr>
              <tr>
                <th class="detail-title">정산요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeAdjustPrice) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterAdjustPrice1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterAdjustPrice2) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.resultAdjustPrice) }}</td>
              </tr>
              <tr v-show="!$Util.isEmpty(assetData.beforeCustomName1)">
                <th class="detail-title">{{ assetData.beforeCustomName1 }}</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeCustomValue1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterCustomValue1_1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterCustomValue1_2) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.resultCustomValue1) }}</td>
              </tr>
              <tr v-show="!$Util.isEmpty(assetData.beforeCustomName2)">
                <th class="detail-title">{{ assetData.beforeCustomName2 }}</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeCustomValue2) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterCustomValue2_1) }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterCustomValue2_2) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.resultCustomValue2) }}</td>
              </tr>
              <tr>
                <th class="detail-title">원단위 절사</th>
                <td class="text-right number">{{ assetData.beforeWonCut }}</td>
                <td class="text-right number">{{ assetData.afterWonCut1 }}</td>
                <td class="text-right number" v-if="assetData.customerType === 2">{{ assetData.afterWonCut2 }}</td>
                <td class="text-right number">-</td>
              </tr>
              <tr>
                <td colspan="5">&nbsp;</td>
              </tr>
              <tr>
                <th class="detail-title">당월 청구요금</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeTotalBill) }}</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.afterTotalBill1) }}</th>
                <th class="text-right number" v-if="assetData.customerType === 2">{{ $Util.formatNumber(assetData.afterTotalBill2) }}</th>
                <th class="text-right number" rowspan="2">
                  {{ $Util.formatNumber(assetData.beforeTotalBill - (assetData.afterTotalBill1 + assetData.afterTotalBill2) + assetData.resultAdjustPrice) }}
                </th>
              </tr>
              <tr>
                <th class="detail-title">합계 금액</th>
                <th class="text-right number">{{ $Util.formatNumber(assetData.beforeTotalBill) }}</th>
                <th class="text-right number" :colspan="assetData.customerType">
                  {{ $Util.formatNumber(assetData.afterTotalBill1 + assetData.afterTotalBill2) }}
                </th>
              </tr>
              <tr>
                <td colspan="1" rowspan="7"></td>
                <th colspan="2" class="detail-title">절감율</th>
                <td class="text-right number" colspan="2">{{ assetData.savePriceRate }}%</td>
              </tr>
              <tr>
                <th colspan="2" class="detail-title">절감액</th>
                <td class="text-right number" colspan="2">{{ $Util.formatNumber(assetData.savePrice) }}</td>
              </tr>
              <tr>
                <th colspan="2" class="detail-title">청구금액 절감액의 {{ assetData.discountRate }}%</th>
                <td class="text-right number" colspan="2">{{ $Util.formatNumber(resultFee) }}</td>
              </tr>
              <tr v-show="!$Util.isEmpty(assetData.resultCustomFeeName1) && !$Util.isEmpty(assetData.resultCustomFeeValue1)">
                <th colspan="2" class="detail-title">{{ assetData.resultCustomFeeName1 }}</th>
                <td class="text-right number" colspan="2">{{ $Util.formatNumber(assetData.resultCustomFeeValue1) }}</td>
              </tr>
              <tr>
                <th colspan="2" class="detail-title">부가세</th>
                <td class="text-right number" colspan="2">{{ $Util.formatNumber(totalResultVat) }}</td>
              </tr>
              <tr v-show="!$Util.isEmpty(assetData.resultCustomVatName1) && !$Util.isEmpty(assetData.resultCustomVatValue1)">
                <th colspan="2" class="detail-title">{{ assetData.resultCustomVatName1 }}</th>
                <td class="text-right number" colspan="2">{{ $Util.formatNumber(assetData.resultCustomVatValue1) }}</td>
              </tr>
              <tr>
                <th colspan="2" class="detail-title">합계</th>
                <td class="text-right number" colspan="2">{{ $Util.formatNumber(totalResult) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="using-wrap">
          <h4 class="sub-title">세부내역 차트</h4>
          <div class="table-wrap" style="border: #136599 solid 2px;">
            <report-bar-chart v-bind:assetData="assetData"
                              :height="200"
                              class="report-bar-chart"
                              ref="reportBarChart">
            </report-bar-chart>
          </div>
        </div>
      </div>
    </div>
    <layout-footer></layout-footer>
  </div>
</template>
<script type="text/javascript">
import ReportBarChart from '@/components/chart/reportBarChart'

export default {
  components: {
    ReportBarChart
  },
  data: function () {
    return {
      isReady: false,
      assetNo: this.$route.query.assetNo,
      assetData: {},
    }
  },
  computed: {
    resultFee: function () {
      return Math.floor(this.assetData.savePrice / 100 * this.assetData.discountRate / 10000) * 10000
    },
    totalResultVat: function () {
      let result = Math.round(this.resultFee * 0.1)
      if (!this.$Util.isEmpty(this.assetData.resultCustomFeeValue1)) {
        result += Math.round(this.assetData.resultCustomFeeValue1 * 0.1)
      }
      return result
    },
    totalResult: function () {
      return Number(this.resultFee)
        + Number(this.assetData.resultCustomFeeValue1)
        + Number(this.assetData.resultCustomVatValue1)
        + Number(this.totalResultVat)
    },
    resultVat: function () {
      return Math.round(this.resultFee * 0.1)
    },
    userData: function () {
      return this.$store.getters['account/getUserData']
    }
  },
  created: function () {
    this.getAssetData()
  },
  methods: {
    downloadReport: function () {
      setTimeout(() => {
        const a = document.createElement('a')
        a.href = this.$ConstCode.CODE_ENV_LIST.REPORT_PATH_URL + this.assetData.reportPath
        a.download = `${this.assetData.assetYear}_${this.assetData.assetMonth}_보고서.xlsx`
        a.target = '_blank'
        a.click()
      }, 1)

      setTimeout(() => {
        if (!this.$Util.isEmpty(this.assetData.totalReportPath)) {
          const a = document.createElement('a')
          a.href = this.$ConstCode.CODE_ENV_LIST.REPORT_PATH_URL + this.assetData.totalReportPath
          a.download = 'download'
          a.click()
        }
      }, 500)
    },
    getAssetData: async function () {
      const res = await this.$AssetSvc.getAssetData({assetNo: this.assetNo})
      const code = res.code
      const message = res.message
      const entity = res.entity

      if (code === 1) {
        this.assetData = entity

        this.isReady = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
